import { apiSlice } from "@/shared/api/api-slice"

import { mapCardStyleResponse } from "./card-style-visuals"

import type { CardStyle, CardStylesCatalogResponse } from "./card-style-types"

export const getCardStylesApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["CardStyles"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      getCardStyles: builder.query<CardStyle[], undefined>({
        query: () => "/api/v1/card-styles",
        transformResponse: (response: CardStylesCatalogResponse): CardStyle[] =>
          Object.values(response.styles)
            .flatMap(styles => styles ?? [])
            .map(mapCardStyleResponse)
            .sort((left, right) => left.sortOrder - right.sortOrder),
        providesTags: [{ type: "CardStyles" as const, id: "LIST" }]
      })
    })
  })

export const { useGetCardStylesQuery } = getCardStylesApi
